import { render, staticRenderFns } from "./ShowMoreItem.vue?vue&type=template&id=1975ea46&"
import script from "./ShowMoreItem.vue?vue&type=script&lang=js&"
export * from "./ShowMoreItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports